import Raven from 'raven-js';
import { rpcClient } from '../../rpcClient';
import { getGrowthPurchaseOptionsRpc } from '../../../__generated__/chirp/com/hubspot/buying/rpc/PublicProductRpc';
export const fetchPurchaseOptions = ({
  productApiNames,
  currencyCode
}) => {
  const purchaseOptionsAndCurrencyByProductApiName = {};
  const buyingMotionPropsByProductApiName = {};
  let promiseError = undefined;
  const requestedProducts = [];
  for (const productApiName of productApiNames) {
    if (!productApiName.includes('free')) {
      requestedProducts.push({
        quantity: 1,
        productApiName
      });
      purchaseOptionsAndCurrencyByProductApiName[productApiName] = {
        currencyCode,
        purchaseOptions: undefined
      };
      buyingMotionPropsByProductApiName[productApiName] = {
        currencyCode,
        products: [{
          productApiName,
          incrementalQuantity: 1
        }]
      };
    }
  }
  return rpcClient.call(getGrowthPurchaseOptionsRpc, {
    request: {
      products: requestedProducts,
      currencyCode
    }
  }).then(purchaseOptionsResponse => {
    for (const [productApiName, productPurchaseOptions] of Object.entries(purchaseOptionsResponse.products)) {
      purchaseOptionsAndCurrencyByProductApiName[productApiName] = {
        currencyCode,
        purchaseOptions: productPurchaseOptions.purchaseOptions
      };
      buyingMotionPropsByProductApiName[productApiName] = {
        currencyCode,
        products: [{
          productApiName,
          incrementalQuantity: 1
        }]
      };
    }
  }, error => {
    promiseError = error;
    Raven.captureException(new Error(error.message, {
      cause: error
    }), {
      extra: {
        productApiNames
      }
    });
  }).catch(purchaseOptionsError => {
    promiseError = purchaseOptionsError;
    Raven.captureException(new Error('fetchPurchaseOptions: Promise successfully resolved but the catch block was triggered', {
      cause: purchaseOptionsError
    }), {
      extra: {
        productApiNames
      }
    });
  }).then(() => {
    if (promiseError) {
      console.error(promiseError);
    }
    return {
      purchaseOptionsAndCurrencyByProductApiName,
      buyingMotionPropsByProductApiName
    };
  });
};
export function tryAndGetEligiblePurchaseOptionByTerm(productPurchaseOptions, term) {
  if (!term) {
    // If no term is provided, try to use the most affordable option,
    // which is typically the annual term, followed by the monthly term. If
    // neither terms are available, then the portal is ineligible to purchase
    // the product.
    if (productPurchaseOptions !== null && productPurchaseOptions !== void 0 && productPurchaseOptions['ANNUAL']) {
      return productPurchaseOptions === null || productPurchaseOptions === void 0 ? void 0 : productPurchaseOptions.ANNUAL;
    } else if (productPurchaseOptions !== null && productPurchaseOptions !== void 0 && productPurchaseOptions.MONTHLY) {
      return productPurchaseOptions.MONTHLY;
    }
    // If term is provided, try to return the purchase option for that term
  } else if (productPurchaseOptions !== null && productPurchaseOptions !== void 0 && productPurchaseOptions[term]) {
    return productPurchaseOptions[term];
    // If no purchase option is available for the provided term, try to use the
    // first purchase option
  } else if (Object.values(productPurchaseOptions).length > 0) {
    return Object.values(productPurchaseOptions)[0];
  }
  return undefined;
}